import axios from "axios";
import authHeader from "./auth-header";
import { clearLegacyAuthStorage } from "@/utils/authStorage";
import refreshCoordinator from "@/services/auth-refresh-coordinator";
import {
  AUTH_BASE_URL,
  AUTH_LOGIN_URL,
} from "@/utils/authFlow";

class AuthService {
  refreshPromise = null;

  // Convert AuthService to a singleton
  constructor() {
    if (AuthService._instance) {
      return AuthService._instance;
    }
    AuthService._instance = this;
  }

  async login(user) {
    const response = await axios.post(
      AUTH_LOGIN_URL,
      {
        email: user.username,
        password: user.password,
      },
      {
        withCredentials: true,
      }
    );
    if (response.data.token) {
      let user = response.data;
      if (!user.permissions.includes("claims-process")) {
        clearLegacyAuthStorage();
        window.location.href = process.env.VUE_APP_GATEWAY_PORTAL_BASE_URL;
        return;
      }
    }
    return response.data;
  }

  async checkToken() {
    const response = await axios.get(AUTH_BASE_URL, {
      withCredentials: true,
    });

    return response.data;
  }

  async refreshToken() {
    if (!this.refreshPromise) {
      this.refreshPromise = refreshCoordinator.refresh().finally(() => {
        this.refreshPromise = null;
      });
    }

    return this.refreshPromise;
  }

  async logout() {
    return axios
      .post(
        AUTH_BASE_URL,
        {},
        {
          headers: authHeader(),
          withCredentials: true,
        }
      )
      .then((response) => {
        clearLegacyAuthStorage();
        window.location.href =
          `${process.env.VUE_APP_GATEWAY_PORTAL_BASE_URL}/login?redirect=` +
          window.location.origin +
          "/login";
      });
  }

  getQR() {
    return axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/auth/2fa`, {
      headers: authHeader(),
      withCredentials: true,
    });
  }

  verify2fa(otp) {
    return axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/api/auth/2fa`,
      { otp: otp },
      { headers: authHeader(), withCredentials: true }
    );
  }
}

export default new AuthService();
